import React from 'react';
import { AuthConsumer } from 'src/app/contexts/authContext';

/**
 * @Usage
 * This component is going to be used after login when the user is going to be redirected by the server
 * to the redirect_uri setted on the IDENTITY_CONFIG
 */
export const CallbackComponent = () => {
    return (
        <AuthConsumer>
            {({ signinRedirectCallback }) => {
                signinRedirectCallback();
                return <span></span>;
            }}
        </AuthConsumer>
    );
};
